// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"378fee97bb2ed365af80","3":"c9de74ae53fff6e6ac2e","4":"2ef3d0f5789353967ff3","5":"dfd1f48bc6df2500869e"}[chunkId] + "";
};